import Vue from "vue";

// =========================
// COMPONENTS
// =========================

// BASE
import LazyImg from "~/app/components/common/LazyImg.vue";
import Intersect from "ceres/app/components/common/Intersect.vue";
import TabList from "ceres/app/components/common/TabList.vue";
import TabItem from "ceres/app/components/common/TabItem.vue";
import LazyLoad from "ceres/app/components/common/LazyLoad.vue";

import ReCaptcha from "ceres/app/components/customer/ReCaptcha.vue";
// legacy non-shopbuilder component
import UserLoginHandler from "~/app/components/customer/login/UserLoginHandler.vue";

import CategoryItem from "~/app/components/itemList/CategoryItem.vue";
import ItemSearch from "~/app/components/itemList/ItemSearch.vue";

import CookieBar from "ceres/app/components/pageDesign/CookieBar.vue";
import Carousel from "ceres/app/components/pageDesign/Carousel.vue";
import Icon from "ceres/app/components/pageDesign/Icon.vue";
import LanguageDetection from "ceres/app/components/pageDesign/LanguageDetection.vue";
import MobileNavigation from "~/app/components/pageDesign/MobileNavigation.vue";
import Notifications from "ceres/app/components/pageDesign/Notifications.vue";
import Popper from "ceres/app/components/pageDesign/Popper.vue";
import LoadingAnimation from "~/app/components/pageDesign/LoadingAnimation.vue";

import WishListCount from "~/app/components/wishList/WishListCount.vue";

import SingleItem from "~/app/components/item/SingleItem.vue";
import SingleItemSetComponent from "ceres/app/components/item/SingleItemSetComponent.vue";

// EXTERNAL
import LazyHydrate from "vue-lazy-hydration";
import ClientOnly from "ceres/app/components/common/ClientOnly.vue";
import script2 from "ceres/app/plugins/script2";
import PortalVue from "portal-vue";
import {Navigation, Pagination, Zoom, Lazy, Swiper} from 'swiper';


// =========================
// DIA COMPONENTS
// =========================


// =========================
// SERVICES
// =========================
import TranslationService from "ceres/app/services/TranslationService";

// =========================
// MIXINS
// =========================
import "ceres/app/mixins/template.mixin";
import "ceres/app/mixins/getJsonData.mixin";

// =========================
// DIRECTIVES
// =========================
import "ceres/app/directives/basket/basketItemQuantity";
import "ceres/app/directives/basket/basketItemSum";
import "ceres/app/directives/basket/toggleBasketPreview";
import "ceres/app/directives/category/openFilterToolbar";
import "ceres/app/directives/common/truncateTooltip";
import "ceres/app/directives/customer/logout";
import "ceres/app/directives/helper/populateStore";
import "ceres/app/directives/helper/validate";
import "ceres/app/directives/helper/waitingAnimation";
import "ceres/app/directives/helper/waitingAnimationInfinite";
import "ceres/app/directives/navigation/navigationTouchHandler";
import "ceres/app/directives/navigation/openMobileNavigation";
import "ceres/app/directives/pageDesign/scrollToTop";
import "ceres/app/directives/pageDesign/stickInParent";
import "ceres/app/directives/navigation/sidenavigationChildrenLoader";
import "ceres/app/directives/pageDesign/tooltip";

// =========================
// DIA DIRECTIVES
// =========================
import "~/app/directives/pageDesign/openMobileSearch";
import "~/app/directives/navigation/openMobileFilter";
import "~/app/directives/navigation/closeOffcanvas";

// =========================
// FILTERS
// =========================
import "ceres/app/filters/ageRestriction.filter";
import "ceres/app/filters/arrayFirst.filter";
import "ceres/app/filters/attachText.filter";
import "ceres/app/filters/currency.filter";
import "ceres/app/filters/date.filter";
import "ceres/app/filters/fileName.filter";
import "ceres/app/filters/fileUploadPath.filter";
import "ceres/app/filters/graduatedPrice.filter";
import "ceres/app/filters/hasItemDefaultPrice.filter";
import "ceres/app/filters/inputUnit.filter";
import "ceres/app/filters/itemBundleName.filter";
import "ceres/app/filters/itemCrossPrice.filter";
import "ceres/app/filters/itemImage.filter";
import "ceres/app/filters/itemImageAlternativeText.filter";
import "ceres/app/filters/itemImages.filter";
import "ceres/app/filters/itemName.filter";
import "ceres/app/filters/itemPrice.filter";
import "ceres/app/filters/itemUrl.filter";
import "ceres/app/filters/numberFormat.filter";
import "ceres/app/filters/propertySurcharge.filter";
import "ceres/app/filters/propertyFileUrl.filter";
import "ceres/app/filters/translate.filter";
import "ceres/app/filters/truncate.filter";

export function beforeCreate(context)
{
    // =========================
    // COMPONENTS
    // =========================

    // BASE
    Vue.component("add-item-to-basket-overlay", () => import("~/app/components/basket/AddItemToBasketOverlay.vue"));
    Vue.component("add-to-basket", () => import("~/app/components/basket/AddToBasket.vue"));
    Vue.component("basket-preview", () => import("~/app/components/basket/BasketPreview.vue"));
    Vue.component("basket-totals", () => import("~/app/components/basket/BasketTotals.vue"));
    Vue.component("mail-changed-info", () => import("ceres/app/components/basket/MailChangedInfo.vue"));

    Vue.component("coupon", () => import("~/app/components/basket/Coupon.vue"));
    Vue.component("basket-list", () => import("~/app/components/basket/list/BasketList.vue"));
    Vue.component("step-by-step-navigation", () => import("ceres/app/components/category/StepByStepNavigation.vue"));
    Vue.component("google-maps-widget", () => import("ceres/app/components/common/GoogleMaps.vue"));
    Vue.component("lazy-img", LazyImg);
    Vue.component("intersect", Intersect);
    Vue.component("tab-list", TabList);
    Vue.component("tab-item", TabItem);
    Vue.component("last-seen-item-list", () => import("ceres/app/components/containers/LastSeenItemList.vue"));
    Vue.component("change-email-form", () => import("ceres/app/components/customer/ChangeEmailForm.vue"));
    Vue.component("recaptcha", ReCaptcha);
    Vue.component("registration", () => import("ceres/app/components/customer/Registration.vue"));
    Vue.component("reset-password-form", () => import("ceres/app/components/customer/ResetPasswordForm.vue"));
    Vue.component("forgot-password-modal", () => import("ceres/app/components/customer/login/ForgotPassword.vue"));
    Vue.component("guest-login", () => import("~/app/components/customer/login/GuestLogin.vue"));
    Vue.component("login", () => import("~/app/components/customer/login/Login.vue"));
    Vue.component("login-b2b", () => import("~/app/components/customer/login/LoginB2b.vue"));
    Vue.component("login-view", () => import("~/app/components/customer/login/LoginView.vue"));
    Vue.component("user-login-handler", UserLoginHandler);
    Vue.component("item-bundle", () => import("ceres/app/components/item/ItemBundle.vue"));
    Vue.component("order-property-value", () => import("ceres/app/components/item/OrderPropertyValue.vue"));
    Vue.component("quantity-input", () => import("~/app/components/item/QuantityInput.vue"));
    Vue.component("tag-list", () => import("ceres/app/components/item/TagList.vue"));
    Vue.component("category-item", CategoryItem);
    Vue.component("item-search", ItemSearch);
    Vue.component("search-suggestion-item", () => import("ceres/app/components/itemList/SearchSuggestionItem.vue"));
    Vue.component("item-filter-list", () => import("~/app/components/itemList/filter/ItemFilterList.vue"));
    Vue.component("item-filter-tag-list", () => import("~/app/components/itemList/filter/ItemFilterTagList.vue"));
    Vue.component("live-shopping-item", () => import("ceres/app/components/liveShopping/LiveShoppingItem.vue"));
    Vue.component("newsletter-input", () => import("~/app/components/newsletter/NewsletterInput.vue"));
    Vue.component("newsletter-unsubscribe-input", () => import("ceres/app/components/newsletter/NewsletterUnsubscribeInput.vue"));
    Vue.component("order-return", () => import("ceres/app/components/orderReturn/OrderReturn.vue"));
    Vue.component("cookie-bar", CookieBar);
    Vue.component("privacy-settings", () => import("ceres/app/components/pageDesign/PrivacySettings.vue"));
    Vue.component("carousel", Carousel);
    Vue.component("icon", Icon);
    Vue.component("language-detection", LanguageDetection);
    Vue.component("mobile-navigation", MobileNavigation);
    Vue.component("notifications", Notifications);
    Vue.component("popper", Popper);
    Vue.component("shipping-country-select", () => import("ceres/app/components/pageDesign/ShippingCountrySelect.vue"));
    Vue.component("loading-animation", LoadingAnimation);
    Vue.component("wish-list", () => import("ceres/app/components/wishList/WishList.vue"));
    Vue.component("wish-list-count", WishListCount);
    Vue.component("lazy-load", LazyLoad);
    Vue.component("add-to-wish-list", () => import("~/app/components/item/AddToWishList.vue"));
    Vue.component("graduated-prices", () => import("ceres/app/components/item/GraduatedPrices.vue"));
    Vue.component("item-data-table", () => import("ceres/app/components/item/ItemDataTable.vue"));
    Vue.component("item-image-carousel", () => import("~/app/components/item/ItemImageCarousel.vue"));
    Vue.component("item-price", () => import("~/app/components/item/ItemPrice.vue"));
    Vue.component("set-price", () => import("ceres/app/components/item/SetPrice.vue"));
    Vue.component("order-property-list", () => import("ceres/app/components/item/OrderPropertyList.vue"));
    Vue.component("variation-select", () => import("ceres/app/components/item/VariationSelect.vue"));
    Vue.component("item-availability", () => import("ceres/app/components/item/ItemAvailability.vue"));
    Vue.component("single-item-bundle", () => import("ceres/app/components/item/SingleItemBundle.vue"));
    Vue.component("single-add-to-basket", () => import("ceres/app/components/item/SingleAddToBasket.vue"));
    Vue.component("set-quantity-input", () => import("ceres/app/components/item/SetQuantityInput.vue"));
    Vue.component("single-item", SingleItem);
    Vue.component("single-item-set-component", SingleItemSetComponent);
    Vue.component("form-attachment", () => import("ceres/app/components/form/FormAttachment.vue"));
    Vue.component("client-only", ClientOnly);
    Vue.component("background-img", () => import("ceres/app/components/common/BackgroundImg.vue"));
    Vue.component("category-add-wishlist", () => import("~/app/components/itemList/AddToWishList.vue"));


    // EXTERNAL
    Vue.component("lazy-hydrate", LazyHydrate);
    Vue.use(script2);
    Vue.use(PortalVue);
    Swiper.use([Navigation, Pagination, Zoom, Lazy]);

    //DIA
    Vue.component("accordion-widget", () => import("~/app/components/widgets/grid/AccordionWidget.vue"));
    Vue.component("item-filter-list-mobile", () => import("~/app/components/itemList/filter/ItemFilterListMobile.vue"));
    Vue.component("load-more-items", () => import("~/app/components/itemList/LoadMoreItems.vue"));
    Vue.component("od-portal-target", () => import("~/app/components/common/OdPortalTarget.vue"));

    Vue.prototype.$translate = TranslationService.translate;
    Vue.prototype.$ceres = App;
}

export function createApp(options, store)
{
    const defaultOptions = {
        store,
        ...options
    };

    const app = new Vue(defaultOptions);

    return app;
}
